import { registerTokenStore, type TokenStore } from '@shared/api/token-store';

// Set global flag so shared API client knows admin scope
if (typeof window !== 'undefined') {
  (window as any).__ECREGI_APP_ROLE = 'admin';
}

// Admin access token is stored in sessionStorage.
// Advantages:
// 1. Isolated per-tab (Tab 1 and Tab 2 don't collide).
// 2. Survives F5 page refresh (never logs out on refresh).
// 3. Destroyed automatically when the browser tab is closed.
// 4. Refresh token is NEVER stored in browser JS storage — it lives in
//    an HttpOnly cookie managed by the browser engine.
const ACCESS = 'ecregi-admin.accessToken';

function get(k: string): string | null {
  try {
    return sessionStorage.getItem(k);
  } catch {
    return null;
  }
}

function set(k: string, v: string | null): void {
  try {
    if (v) sessionStorage.setItem(k, v);
    else sessionStorage.removeItem(k);
  } catch {
    /* ignore */
  }
}

// Clean up legacy localStorage if present from prior builds
function purgeLegacyLocalStorage() {
  try {
    localStorage.removeItem('ecregi-admin.accessToken');
    localStorage.removeItem('ecregi-admin.refreshToken');
  } catch {
    /* ignore */
  }
}

const store: TokenStore = {
  getAccessToken: () => {
    const raw = get(ACCESS);
    if (raw) return raw;
    return get('ecregi_admin.session') ? 'cookie-session' : null;
  },
  setAccessToken: (t) => set(ACCESS, t || 'cookie-session'),
  getRefreshToken: () => null,
  setRefreshToken: () => {
    // No-op: refresh tokens are handled securely via HttpOnly cookies
  },
  clear: () => {
    set(ACCESS, null);
    try {
      sessionStorage.removeItem('ecregi_admin.session');
    } catch {
      /* ignore */
    }
    purgeLegacyLocalStorage();
  },
};

export function installAdminTokenStore() {
  purgeLegacyLocalStorage();
  registerTokenStore(store);
}
